import { runMutation, runQuery } from '../graphQl'
import {
  CreateFactoryMutation,
  GetAllFactoriesQuery,
  updateFactoryMutation,
  GetResourceTypesQuery,
  GetResourcesFromResourceMasterQuery,
  addVendorToFactory,
  GetLinkedVendors,
  GetSkillsRequiredQuery,
  CreateResourceinstanceMutation,
  GetAllResourcesQuery,
  GetCurrentFactoryQuery,
  AddSupervisorToFactoryMutation,
  RemoveUserFromFactoryMutation,
  getFactoryStorageBinQuery,
  createStorageBinQuery,
  GetInventoryDataQuery,
  UpdateBinStatusQuery,
  UpdateFactoryResourcesQuery,
  factoryResourceAssociationQuery,
  AddUserToFactoryMutation,
  ChangeUserRoleMutation
} from '../query/factory'

export const CreateFactory = (data) => {
  return runMutation(CreateFactoryMutation(), { data }, 'tenant')
}

export const GetCurrentFactory = (id) => {
  return runQuery(GetCurrentFactoryQuery(), { id }, 'factory')
}

export const AddSupervisorToFactory = (factoryUsers) => {
  return runMutation(AddSupervisorToFactoryMutation(), { factoryUsers }, 'tenant')
}

export const AddUserToFactory = (userId, roleId) => {
  return runMutation(AddUserToFactoryMutation(), { userId, roleId }, 'factory')
}

export const RemoveUserFromFactory = (userIds, useFactoryToken = false, factoryId) => {
  let token = 'tenant'
  const conditions = { user_id: { _in: userIds } }
  if (useFactoryToken) {
    token = 'factory'
  } else {
    conditions.project_id = { _eq: factoryId }
  }
  return runMutation(RemoveUserFromFactoryMutation(), { conditions }, token)
}

export const ChangeUserRole = (userId, roleId) => {
  return runMutation(ChangeUserRoleMutation(), { userId, roleId }, 'factory')
}

export const GetAllFactories = (sorting = '1', selectedTab = 'active') => {
  const conditions = { deleted: { _eq: false }, is_factory: { _eq: true } }
  let orderBy = { created_on: 'desc' }
  if (sorting === '2') {
    orderBy = { created_on: 'asc' }
  } else orderBy = { created_on: 'desc' }
  if (selectedTab === 'active') {
    conditions.active = { _eq: true }
  } else {
    conditions.active = { _eq: false }
  }
  return runQuery(GetAllFactoriesQuery(), { conditions, orderBy }, 'tenant')
}

export const UpdateFactory = (data, id) => {
  return runMutation(updateFactoryMutation(), { data, id }, 'tenant')
}

export const GetResourceTypes = () => {
  return runQuery(GetResourceTypesQuery(), {}, 'tenant')
}

export const GetResourcesFromResourceMaster = (type) => {
  return runQuery(GetResourcesFromResourceMasterQuery(), { type }, 'tenant')
}

export const GetSkillsRequired = () => {
  return runQuery(GetSkillsRequiredQuery(), {}, 'tenant')
}

export const CreateResourceInstance = (input) => {
  return runMutation(CreateResourceinstanceMutation(), { input }, 'factory')
}

export const GetAllResourceInstances = () => {
  return runQuery(GetAllResourcesQuery(), {}, 'factory')
}

export const AddVendorToFactory = (defaultCollab) => {
  return runMutation(addVendorToFactory(), { defaultCollab }, 'factory')
}

export const GetLinkedVendorsList = (factoryId) => {
  return runQuery(GetLinkedVendors(), { factory_id: factoryId }, 'factory')
}

export const GetFactoryStorageBin = () => {
  return runQuery(getFactoryStorageBinQuery(), {}, 'factory')
}

export const createStorageBin = (count = 1, sequenceInput) => {
  return runMutation(createStorageBinQuery(), { count, sequenceInput }, 'factory')
}

export const GetFactoryMaterials = (filter, sorting) => {
  const conditions = []
  let orderBy = { created_on: 'desc' }
  if (sorting === '2') {
    orderBy = { created_on: 'asc' }
  } else if (sorting === '1') {
    orderBy = { created_on: 'desc' }
  } else if (sorting === '3') {
    orderBy = { material_name: 'asc' }
  } else if (sorting === '4') orderBy = { material_name: 'desc' }
  filter.orderBy = orderBy
  if (filter.tagId) {
    conditions.push({
      tag_materials: { tag_id: { _eq: filter.tagId } }
    })
  }
  if (filter.type === 'material') {
    conditions.push({
      type: {
        _eq: 1
      }
    })
  } else if (filter.type === 'resource') {
    conditions.push({
      type: {
        _eq: 2
      }
    })
  }
  filter.type = undefined
  if (filter.searchKeyword) {
    conditions.push({
      _or: [
        { custom_material_id: { _ilike: filter.searchKeyword } },
        { erp_material_id: { _ilike: filter.searchKeyword } },
        { material_description: { _ilike: filter.searchKeyword } },
        { material_name: { _ilike: filter.searchKeyword } },
        { plm_material_id: { _ilike: filter.searchKeyword } },
        {
          material_product_code: { product_code: { _ilike: filter.searchKeyword } }
        }
      ]
    })
  }
  if (filter.customListItmes) {
    if (Object.hasOwn(filter.customListItmes, 'resource_group')) {
      conditions.push({
        resource_group: { _eq: filter.customListItmes.resource_group.id }
      })
    }
    if (Object.hasOwn(filter.customListItmes, 'material_group')) {
      conditions.push({
        material_group: { _eq: filter.customListItmes.material_group.id }
      })
    }
    if (Object.hasOwn(filter.customListItmes, 'unit_of_material')) {
      conditions.push({
        unit_of_material: { _eq: filter.customListItmes?.unit_of_material?.id }
      })
    }
    if (Object.hasOwn(filter.customListItmes, 'weight_unit')) {
      conditions.push({
        weight_unit: { _eq: filter.customListItmes.weight_unit?.id }
      })
    }
    if (Object.hasOwn(filter.customListItmes, 'storage_loc')) {
      conditions.push({
        storage_loc: { _eq: filter.customListItmes.storage_loc.id }
      })
    }
  }

  if (filter.effectiveDate) {
    if (filter.effectiveDate.from && filter.effectiveDate.to) {
      conditions.push({
        effective_date: { _gte: new Date(filter.effectiveDate.from), _lte: new Date(filter.effectiveDate.to) }
      })
    } else if (filter.effectiveDate.from) {
      conditions.push({
        effective_date: { _gte: new Date(filter.effectiveDate.from) }
      })
    } else if (filter.effectiveDate.to) {
      conditions.push({
        effective_date: { _lte: new Date(filter.effectiveDate.to) }
      })
    }
  }
  if (filter.leadtime) {
    if ((filter.leadtime.from || filter.leadtime.from === 0) && filter.leadtime.to) {
      conditions.push({
        lead_time: { _gte: parseInt(filter.leadtime.from), _lte: parseInt(filter.leadtime.to) }
      })
    } else if (filter.leadtime.from || filter.leadtime.from === 0) {
      conditions.push({
        lead_time: { _gte: parseInt(filter.leadtime.from) }
      })
    } else if (filter.leadtime.to) {
      conditions.push({
        lead_time: { _lte: parseInt(filter.leadtime.to) }
      })
    }
  }
  if (filter.resourseStatusId) {
    conditions.push({
      resource_state_value: { id: { _eq: parseInt(filter.resourseStatusId) } }
    })
  }
  if (filter.id) {
    conditions.push({
      id: { _eq: filter.id }
    })
    filter.id = undefined
  }
  filter.resourseStatusId = undefined
  if (conditions.length > 0) {
    filter.conditions = {
      _and: conditions
    }
  }
  filter.effectiveDate = undefined
  filter.leadtime = undefined
  filter.searchKeyword = undefined
  filter.tagId = undefined
  filter.customListItmes = undefined
  return runQuery(GetInventoryDataQuery(), filter, 'factory')
}

export const UpdateBinStatus = (id, status) => {
  return runMutation(UpdateBinStatusQuery(), { id, status }, 'factory')
}

export const UpdateFactoryResources = (id, updateObj) => {
  return runMutation(UpdateFactoryResourcesQuery(), { id, updateObj }, 'factory')
}

export const getFactoryResourceAssociations = (factoryId, resourceIds, isOnProjectLevel, state = ['IDLE', 'RUNNING']) => {
  return runQuery(factoryResourceAssociationQuery(), { factoryId, resourceIds, state }, isOnProjectLevel ? 'project' : 'tenant')
}
